import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import voteService from "./voteService";

const initialState = {
  vote: null,
  votes: [],
  // articles: [],
  // comments: [],
  // options: [],
  isError: false,
  isLoading: false,
  message: "",
};

// Create Product
export const createVote = createAsyncThunk(
  "votes/createVote",
  async (formData, thunkAPI) => {
    try {
      return await voteService.createVote(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Products
export const getVotes = createAsyncThunk(
  "votes/getVotes",
  async (_, thunkAPI) => {
    try {
      return await voteService.getVotes();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete Product
export const deleteVote = createAsyncThunk(
  "votes/deleteVote",
  async (id, thunkAPI) => {
    try {
      return await voteService.deleteVote(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Product
export const getVote = createAsyncThunk(
  "votes/getVote",
  async (id, thunkAPI) => {
    try {
      return await voteService.getVote(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update Product
export const updateVote = createAsyncThunk(
  "votes/updateVote",
  async ({ id, formData }, thunkAPI) => {
    try {
      return await voteService.updateVote(id, formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// // addComment
// export const addVote = createAsyncThunk(
//   "votes/addVote",
//   async ({ id, formData }, thunkAPI) => {
//     try {
//       return await voteService.addVote(id, formData);
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

const voteSlice = createSlice({
  name: "vote",
  initialState,
  reducers: {
    RESET_PROD(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      // create Product
      .addCase(createVote.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createVote.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        // console.log(action.payload);
        if (action.payload && action.payload.hasOwnProperty("message")) {
          toast.error(action.payload.message);
        } else {
          state.message = "Vote created Successful";
          toast.success("Vote created Successful");
        }
      })
      .addCase(createVote.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get Products
      .addCase(getVotes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVotes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.votes = action.payload;
        // console.log(action.payload);
      })
      .addCase(getVotes.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // toast.error(action.payload);
      })

      // Delete Product
      .addCase(deleteVote.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteVote.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        toast.success("Vote deleted successfully");
      })
      .addCase(deleteVote.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Get Product
      .addCase(getVote.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVote.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.vote = action.payload;
        // console.log(action.payload);
      })
      .addCase(getVote.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      // Update Post
      .addCase(updateVote.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateVote.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        console.log(action.payload);
        if (action.payload && action.payload.hasOwnProperty("message")) {
          toast.error(action.payload.message);
        } else {
          state.message = "Post updated Successful";
          toast.success("Post updated Successful");
        }
      })
      .addCase(updateVote.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      });

    // // addComment
    // .addCase(addVote.pending, (state) => {
    //   state.isLoading = true;
    // })
    // .addCase(addVote.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.isSuccess = true;
    //   state.isError = false;
    //   state.comments = action.payload;
    //   toast.success(action.payload);
    // })
    // .addCase(addVote.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.isError = true;
    //   state.message = action.payload;
    //   toast.error(action.payload);
    // });
  },
});

// export const { RESET_PROD, GET_PRICE_RANGE } = voteSlice.actions;

export const selectVote = (state) => state.vote.vote;
export const selectVotes = (state) => state.vote.votes;
// export const selectComments = (state) => state.vote.comments;
export const selectIsLoading = (state) => state.vote.isLoading;

export default voteSlice.reducer;
